import { saveSSESequenceId, loadSSESequenceId, clearSSESequenceId, getOrigin } from "../utils/widgetStorage";
import { axiosUCS } from "../configs/http-config";

export class SSEClient {
	#es = null;
	#closed = false;

	constructor(conversationId, contactId, tenantId, sessionId, botId, callbacks = {}) {
		if (!conversationId || !contactId || !tenantId) return;
		this._conversationId = conversationId;
		this._contactId = contactId;
		this._tenantId = tenantId;
		this._sessionId = sessionId;
		this._botId = botId;
		this._callbacks = callbacks;
		this.#connect();
	}

	#buildUrl() {
		const storedSeq = loadSSESequenceId(this._conversationId);
		const origin = getOrigin() || {};
		const xHost = (origin.hostname || "").replace(/^https?:\/\//, "");
		return axiosUCS.getUri({
			url: `/sse/stream/${this._conversationId}/${this._contactId}`,
			params: {
				tenantId: this._tenantId,
				botId: this._botId,
				xHost,
				xPathname: origin.pathname || "",
				...(this._sessionId ? { sessionId: this._sessionId } : {}),
				...(storedSeq ? { sequence: storedSeq } : {}),
			},
		});
	}

	#connect() {
		if (this.#closed) return;
		try {
			this.#es = new EventSource(this.#buildUrl());
			this.#attachListeners();
		} catch (_) { /* EventSource constructor failed */ }
	}

	#attachListeners() {
		const es = this.#es;

		es.addEventListener("connected", () => { this._callbacks.onConnected?.(); });

		es.addEventListener("stream_chunk", (e) => {
			try {
				const data = JSON.parse(e.data);
				if (data.sequenceId) {
					saveSSESequenceId(this._conversationId, data.sequenceId);
				}
				this._callbacks.onChunk?.(data);
			} catch (_) { /* malformed event data */ }
		});

		es.addEventListener("stream_done", (e) => {
			try {
				const data = JSON.parse(e.data);
				if (data.sequenceId) {
					saveSSESequenceId(this._conversationId, data.sequenceId);
				}
				this._callbacks.onDone?.(data);
				clearSSESequenceId(this._conversationId);
			} catch (_) { /* malformed event data */ }
		});

		es.onerror = e => this._callbacks.onError?.(e);
	}

	destroy() {
		if (this.#closed) return;
		this.#closed = true;
		this.#es?.close();
		this.#es = null;
	}

	get isOpen() {
		return this.#es?.readyState === EventSource.OPEN;
	}
}
